// src/context/WebSocketProvider.jsx
import React, { createContext, useContext, useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { useSnackbar } from "../App"; 

const WebSocketContext = createContext(null);

export const useOrderSocket = () => useContext(WebSocketContext);

export const WebSocketProvider = ({ children }) => {
  const socketRef = useRef(null);
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const socket = io(process.env.REACT_APP_SOCKET_URL || "https://billingws.svmsweets.com", {
      auth: { token },
      transports: ["websocket"],
    });

    socketRef.current = socket;

    socket.on("connect", () => {
      console.log("Global WebSocket connected");
    });

    socket.on("order_status_update", (data) => {
      console.log("Global order update:", data);
      const statusLabel = {
        order_placed: "Order Placed",
        preparing: "Preparing",
        ready_for_delivery: "Ready for Delivery",
        completed: "Completed",
        cancelled: "Cancelled",
      }[data.status] || data.status;

      showSnackbar(
        `Order ${data.order_number || data.order_id} → ${statusLabel}`,
        "success"
      );

      // Dispatch custom event so any component can listen
      window.dispatchEvent(
        new CustomEvent("orderStatusUpdate", { detail: data })
      );
    });

    socket.on("sidebar_refresh", (data) => {
      console.log("Global sidebar refresh:", data);
      window.dispatchEvent(
        new CustomEvent("sidebarRefresh", { detail: data })
      );
    });

    socket.on("disconnect", () => {
      console.log("WebSocket disconnected");
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <WebSocketContext.Provider value={socketRef.current}>
      {children}
    </WebSocketContext.Provider>
  );
};